<app-card [contentType]="'statistics'" [hidHeader]="true">
    <div class="row" *ngIf="icon">
        <div class="col-3 d-flex align-items-center justify-content-center">
            <app-custom-icons *ngIf="iconType === 'custom'" [icon]="icon" [color]="'#F8E173'" [size]="'40px'"></app-custom-icons>
            <i [style.color]="'#F8E173'" *ngIf="iconType === 'feather'" class="feather" [class]="icon"></i>
        </div>
        <div class="col-9 d-flex align-items-start justify-content-center flex-column">
            <span class="h2 mb-0 font-weight-lighter text-dark">{{data.value}}</span>
            <span class="text-uppercase font-weight-lighter text-dark">{{data.label}}</span>
        </div>
    </div>
    <div class="row" *ngIf="!icon">
        <div class="col-12">
            <span class="h5 font-size-lighter">{{data.label}}</span>
        </div>
        <ul class="list-group list-group-flush w-100" *ngIf="data.itemsList.length">
            <li *ngFor="let item of data.itemsList" class="list-group-item">
                <div class="row">
                    <div class="col-6">
                        <app-custom-icons [icon]="'interactions.svg'" [color]="'#F8E173'" [size]="'20px'" class="d-inline-block"></app-custom-icons>
                        <span class="d-inline-block ml-2">{{ (item.title.length>20)? (item.title | slice:0:20)+'..':(item.title) }}</span>
                    </div>
                    <div class="col-3">140 views</div>
                    <div class="col-3">35 player</div>
                </div>
            </li>
        </ul>
    </div>
</app-card>